export default "__VITE_ASSET__BlYWHXQr__"